module.exports = {
  '@primary-color': '#4635AC',
  '@info-color': '#1890ff',
  '@success-color': '#388E3C',
  '@processing-color': '#F4A01D',
  '@error-color': '#B00020',
  '@highlight-color': '#B00020',
  '@warning-color': '#F4A01D',
  '@normal-color': '#F0F1F3',
  '@body-background': '#F6F7F9',
  '@font-size-base': '14px',
  '@font-size-sm': '10px',
  '@btn-primary-color': '#ffffff',
  '@btn-disable-color': '#262626',
  '@font-family': 'Hind',

  '@checkbox-color': '#fa075a',
  '@radio-dot-color': '#fa075a',
  // sem estes, hover/clique/foco do Radio.Button derivam de @primary-color e misturam com o rosa do selecionado
  '@radio-button-hover-color': 'tint(#fa075a, 20%)',
  '@radio-button-active-color': 'shade(#fa075a, 10%)',
  '@radio-button-focus-shadow': '0 0 0 3px fade(#fa075a, 12%)',
  '@switch-color': '#fa075a',
  '@input-hover-border-color': '#fa075a',
  '@outline-color': '#fa075a',
  '@input-number-handler-border-color': '#fa075a',
  '@input-number-hover-border-color': '#fa075a',
  '@item-hover-bg': '#E4E5E7',
  '@select-item-selected-bg': '#E4E5E7',
  '@select-item-active-bg': '#E4E5E7',
  '@input-border-color': '#fa075a',
};
